import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSite, deleteSite, createSite } from "../services/siteApi";

export function useCreateSite(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSite,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);

      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateSite(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSite,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteSite(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSite,
    onSuccess: (_, publicId) => {
      console.log(`${publicId} has been removed successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.filter((item) => item.public_id !== publicId));
      handleSuccess?.();
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
